import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useLocation } from 'react-router-dom';
import './FreeOddsAnnouncement.css';

export const FREE_ODDS_ANNOUNCEMENT_KEY = 'fantasybet.announcements.freePercentageOdds.v1';

export default function FreeOddsAnnouncement({ eligible }) {
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(FREE_ODDS_ANNOUNCEMENT_KEY) === 'seen'; }
    catch { return false; }
  });
  const close = () => {
    setDismissed(true);
    try { localStorage.setItem(FREE_ODDS_ANNOUNCEMENT_KEY, 'seen'); }
    catch { /* Still dismiss for this visit if browser storage is unavailable. */ }
  };
  const show = eligible && !dismissed && !['/login', '/unsubscribe'].includes(pathname);

  return <Modal show={show} onHide={close} centered scrollable
    className='free-odds-announcement' backdropClassName='free-odds-announcement-backdrop'
    aria-labelledby='free-odds-announcement-title'>
    <Modal.Header closeButton closeVariant='white' className='bg-lightgreen text-white border-0'>
      <Modal.Title id='free-odds-announcement-title' className='h5 fw-bold'>
        <span className='text-orange'>% odds</span> are now free!
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className='bg-lightgreen text-white pt-0'>
      <p>Switch between decimal odds and percentages <strong>no Premium needed.</strong></p>
      <p className='mb-0'>Tap the <strong className='text-orange'>%</strong> toggle beside the match search bar to try it.</p>
    </Modal.Body>
    <Modal.Footer className='bg-lightgreen border-0'>
      <button type='button' className='btn btn-prim text-white fw-bold px-4' onClick={close}>Got it</button>
    </Modal.Footer>
  </Modal>;
}
